import { useState } from 'react'

export default (): [Set<string>, (id: string) => void, (all: string[]) => void] => {
    const [list, updateList] = useState<Set<string>>(new Set())

    function toggleAggregation(id: string): void {
        updateList(state => {
            if (state.has(id)) {
                state.delete(id)
            } else {
                state.add(id)
            }

            return new Set(state)
        })
    }

    function toggleAll(all: string[]): void {
        updateList((state: Set<string>) => {
            if (all.length === state.size) {
                return new Set()
            } else {
                all.forEach(s => state.add(s))
            }

            return new Set(state)
        })
    }

    return [list, toggleAggregation, toggleAll]
}
